"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nUtil = void 0;
const react_native_i18n_1 = __importDefault(require("react-native-i18n"));
const react_native_1 = require("react-native");
const f2e_utils_config_1 = require("@kiki/f2e.utils.config");
const getAppLocale = () => {
    let appLocale = '';
    switch (react_native_1.Platform.OS) {
        case 'android':
            appLocale = react_native_1.NativeModules.I18nManager.localeIdentifier;
            break;
        case 'ios':
            appLocale = react_native_1.NativeModules.SettingsManager.settings.AppleLocale;
            break;
        case 'web':
            appLocale = typeof window !== 'undefined' ? window.navigator.language : 'en';
            break;
    }
    return appLocale;
};
const getLocaleCode = () => {
    const appLocale = getAppLocale();
    const arr = appLocale.replace(/-/g, '_').split('_');
    let lang = arr[0];
    lang = lang.toLowerCase();
    if (['zh'].indexOf(lang) !== -1) {
        if (['zh-hant', 'zh_hk', 'zh_tw'].includes(appLocale.toLowerCase())) {
            return 'hk';
        }
        return 'zh';
    }
    if (arr.length === 3) {
        if (['hant'].includes(appLocale.toLowerCase())) {
            return 'hk';
        }
        if (['hans'].includes(appLocale.toLowerCase())) {
            return 'zh';
        }
    }
    return 'en';
};
const updateLocale = (newLocale) => {
    react_native_i18n_1.default.locale_new = newLocale;
    react_native_i18n_1.default.defaultLocale = newLocale;
    react_native_i18n_1.default.locale = newLocale;
};
const init = (langData) => {
    react_native_i18n_1.default.fallbacks = true;
    react_native_i18n_1.default.defaultSeparator = '__';
    react_native_i18n_1.default.translations = langData;
};
const localeCode = getLocaleCode();
updateLocale(localeCode);
exports.I18nUtil = {
    locale: react_native_i18n_1.default.locale,
    defaultLocale: react_native_i18n_1.default.defaultLocale,
    locale_new: react_native_i18n_1.default.locale_new,
    init,
    t(msg = '', options) {
        const that = this;
        options = options !== null && options !== void 0 ? options : {};
        const reg = /\$\{.*?\}/g;
        const keys = msg.match(reg);
        if (keys) {
            return msg.replace(reg, (param) => {
                const key = param.substring(2, param.length - 1);
                return that.t(key);
            });
        }
        else if ((react_native_i18n_1.default.t(msg, options)).indexOf('missing') === -1) {
            return (react_native_i18n_1.default.t(msg, options));
        }
        return react_native_i18n_1.default.translations.en && react_native_i18n_1.default.translations.en[msg] ? react_native_i18n_1.default.translations.en[msg] : msg;
    },
    setLocale(newLocale) {
        if (!['en', 'hk', 'zh'].includes(newLocale)) {
            return;
        }
        react_native_i18n_1.default.locale = newLocale;
        exports.I18nUtil.locale = newLocale;
        react_native_i18n_1.default.locale_new = newLocale;
        exports.I18nUtil.locale_new = newLocale;
    },
    mergeRemoteLocale(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const urls = [
                `${f2e_utils_config_1.config.api.kiki_website_url}language/${locale.toLowerCase()}.json?a=${Date.now()}`,
                `${f2e_utils_config_1.config.api.kiki_website_url}language/coinDesc-${locale.toLowerCase()}.json?a=${Date.now()}`,
                `${f2e_utils_config_1.config.api.kiki_website_url}language/zoneDesc-${locale.toLowerCase()}.json?a=${Date.now()}`,
                `${f2e_utils_config_1.config.api.kiki_website_url}language/api-${locale.toLowerCase()}.json?a=${Date.now()}`,
                `${f2e_utils_config_1.config.api.kiki_website_url}language/data-${locale.toLowerCase()}.json?a=${Date.now()}`
            ];
            const promises = urls.map((url) => this.fetchRemoteLocale(url));
            try {
                const responses = yield Promise.all(promises);
                const originI18n = {};
                Object.assign(originI18n, ...responses);
                switch (locale) {
                    case 'en':
                        react_native_i18n_1.default.translations.en = Object.assign(Object.assign({}, react_native_i18n_1.default.translations.en), originI18n);
                        break;
                    case 'hk':
                        react_native_i18n_1.default.translations.hk = Object.assign(Object.assign({}, react_native_i18n_1.default.translations.hk), originI18n);
                        break;
                    case 'zh':
                        react_native_i18n_1.default.translations.zh = Object.assign(Object.assign({}, react_native_i18n_1.default.translations.zh), originI18n);
                        break;
                }
            }
            catch (error) {
            }
        });
    },
    fetchRemoteLocale(url) {
        return new Promise((resolve, _reject) => {
            fetch(url)
                .then((response) => response.json()).then((data) => {
                resolve(data);
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    languageTransition: function (language) {
        console.log('language', language);
        if (!language) {
            return 'en';
        }
        const arr = language.replace(/-/g, '_').split('_');
        const arrLanguage = ['zh-hant', 'zh_hk', 'zh-hk', 'zh_tw', 'zh-tw'];
        let lang = arr[0];
        lang = lang.toLowerCase();
        if (['en'].indexOf(lang) !== -1) {
            return 'en';
        }
        else if (['zh'].indexOf(lang) !== -1) {
            if (language.toLowerCase().indexOf('zh-hant') !== -1 || arrLanguage.includes(language.toLowerCase())) {
                return 'hk';
            }
            else {
                return 'zh';
            }
        }
        if (arr.length === 3) {
            if (language.toLowerCase().indexOf('hant') !== -1) {
                return 'hk';
            }
            else if (language.toLowerCase().indexOf('hans') !== -1) {
                return 'zh';
            }
            else {
                return 'en';
            }
        }
    },
};
//# sourceMappingURL=i18n.js.map